"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosQon = void 0;
var axios_1 = require("axios");
var AxiosQon = /** @class */ (function () {
    function AxiosQon(config) {
        var axiosConfig = {
            withCredentials: true,
            baseURL: config.getBaseUrl(),
            timeout: 3000,
        };
        var quarticCookie = config.getCookie();
        if (config.getCookie()) {
            axiosConfig['headers'] = {
                Cookie: "quartic_cookie=".concat(quarticCookie, ";")
            };
        }
        this.axiosInstance = axios_1.default.create(axiosConfig);
    }
    return AxiosQon;
}());
exports.AxiosQon = AxiosQon;
//# sourceMappingURL=AxiosQon.js.map